import { SkinnedMesh } from "three";
import { Scene } from "three";
import { Points } from "three";
import { Group } from "three";
import { FrontSide } from "three";
import { Bone } from "three";
import { PointsMaterial } from "three";
import { MeshStandardMaterial } from "three";
import { LineBasicMaterial } from "three";
import { Object3D } from "three";
import { Mesh } from "three";
import { LineSegments } from "three";
import { LOD } from "three";
import { Poly } from "../../engine/Poly";
export var ObjectType = /* @__PURE__ */ ((ObjectType2) => {
  ObjectType2["OBJECT3D"] = "Object3D";
  ObjectType2["GROUP"] = "Group";
  ObjectType2["MESH"] = "Mesh";
  ObjectType2["POINTS"] = "Points";
  ObjectType2["LINE_SEGMENTS"] = "LineSegments";
  ObjectType2["LOD"] = "LOD";
  return ObjectType2;
})(ObjectType || {});
export const OBJECT_CONSTRUCTOR_BY_OBJECT_TYPE = {
  ["Mesh" /* MESH */]: Mesh,
  ["Group" /* GROUP */]: Group,
  ["Points" /* POINTS */]: Points,
  ["LineSegments" /* LINE_SEGMENTS */]: LineSegments,
  ["Object3D" /* OBJECT3D */]: Object3D,
  ["LOD" /* LOD */]: LOD
};
export function objectTypeFromConstructor(constructor) {
  switch (constructor) {
    case Object3D:
      return "Object3D" /* OBJECT3D */;
    case Group:
      return "Group" /* GROUP */;
    case Mesh:
      return "Mesh" /* MESH */;
    case Points:
      return "Points" /* POINTS */;
    case LineSegments:
      return "LineSegments" /* LINE_SEGMENTS */;
    case LOD:
      return "LOD" /* LOD */;
    default:
      return "Mesh" /* MESH */;
  }
}
export function ObjectTypeByObject(object) {
  if (object instanceof Mesh) {
    return "Mesh" /* MESH */;
  } else if (object instanceof Group) {
    return "Group" /* GROUP */;
  } else if (object instanceof LineSegments) {
    return "LineSegments" /* LINE_SEGMENTS */;
  } else if (object instanceof Points) {
    return "Points" /* POINTS */;
  } else if (object instanceof Object3D) {
    return "Object3D" /* OBJECT3D */;
  }
  Poly.warn("ObjectTypeByObject received an unknown object type", object);
}
export const ObjectTypes = ["Mesh" /* MESH */, "Points" /* POINTS */, "LineSegments" /* LINE_SEGMENTS */];
export const ObjectTypeMenuEntries = [
  { name: "Mesh", value: ObjectTypes.indexOf("Mesh" /* MESH */) },
  { name: "Points", value: ObjectTypes.indexOf("Points" /* POINTS */) },
  { name: "LineSegments", value: ObjectTypes.indexOf("LineSegments" /* LINE_SEGMENTS */) }
];
const materials = {
  MeshStandard: new MeshStandardMaterial({
    color: 16777215,
    side: FrontSide,
    metalness: 0.5,
    roughness: 0.9
  }),
  ["Mesh" /* MESH */]: new MeshStandardMaterial({
    color: 16777215,
    side: FrontSide,
    metalness: 0,
    roughness: 0.9
  }),
  ["Points" /* POINTS */]: new PointsMaterial({
    color: 16777215,
    size: 0.1,
    depthTest: true
  }),
  ["LineSegments" /* LINE_SEGMENTS */]: new LineBasicMaterial({
    color: 16777215,
    linewidth: 1
  })
};
export var AttribClass = /* @__PURE__ */ ((AttribClass2) => {
  AttribClass2[AttribClass2["VERTEX"] = 0] = "VERTEX";
  AttribClass2[AttribClass2["OBJECT"] = 1] = "OBJECT";
  return AttribClass2;
})(AttribClass || {});
export const ATTRIBUTE_CLASSES = [0 /* VERTEX */, 1 /* OBJECT */];
export const AttribClassMenuEntries = [
  { name: "vertex", value: 0 /* VERTEX */ },
  { name: "object", value: 1 /* OBJECT */ }
];
export var AttribType = /* @__PURE__ */ ((AttribType2) => {
  AttribType2[AttribType2["NUMERIC"] = 0] = "NUMERIC";
  AttribType2[AttribType2["STRING"] = 1] = "STRING";
  return AttribType2;
})(AttribType || {});
export const ATTRIBUTE_TYPES = [0 /* NUMERIC */, 1 /* STRING */];
export const AttribTypeMenuEntries = [
  { name: "numeric", value: 0 /* NUMERIC */ },
  { name: "string", value: 1 /* STRING */ }
];
export var AttribSize = /* @__PURE__ */ ((AttribSize2) => {
  AttribSize2[AttribSize2["FLOAT"] = 1] = "FLOAT";
  AttribSize2[AttribSize2["VECTOR2"] = 2] = "VECTOR2";
  AttribSize2[AttribSize2["VECTOR3"] = 3] = "VECTOR3";
  AttribSize2[AttribSize2["VECTOR4"] = 4] = "VECTOR4";
  return AttribSize2;
})(AttribSize || {});
export const ATTRIBUTE_SIZES = [
  1 /* FLOAT */,
  2 /* VECTOR2 */,
  3 /* VECTOR3 */,
  4 /* VECTOR4 */
];
export const ATTRIBUTE_SIZE_RANGE = [1 /* FLOAT */, 4 /* VECTOR4 */];
export const CoreConstant = {
  ATTRIB_CLASS: {
    VERTEX: 0 /* VERTEX */,
    OBJECT: 1 /* OBJECT */
  },
  OBJECT_TYPES: ObjectTypes,
  CONSTRUCTOR_NAMES_BY_CONSTRUCTOR_NAME: {
    [Scene.name]: "Scene",
    [Group.name]: "Group",
    [Object3D.name]: "Object3D",
    [Mesh.name]: "Mesh",
    [Points.name]: "Points",
    [LineSegments.name]: "LineSegments",
    [Bone.name]: "Bone",
    [SkinnedMesh.name]: "SkinnedMesh"
  },
  CONSTRUCTORS_BY_NAME: {
    ["Mesh" /* MESH */]: Mesh,
    ["Points" /* POINTS */]: Points,
    ["LineSegments" /* LINE_SEGMENTS */]: LineSegments
  },
  MATERIALS: materials
};
